import Component from './Component';
import Dropdown from './Dropdown';
import axios from 'axios';
import { togglePreloader } from './../services/ScrollResizeHandler';
import { renderArticleItemTemp, noResultsTemp } from './../services/Templates';
import { filterArray } from './../utilities/filter_array';
import { focus } from './../services/FormValidation';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

let params = new Map();
let newPromise;
let currPage = 1;
let maxPage = 1;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

function setParam (key, value) {
    if (key || value == '') { params.delete(key); }
    params.set(key, value);

    return params;
}




/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Search extends Component {

    decorator () {
        return {
            selector : '.js-search',
            name : 'Search',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        focus(this.searchInput);

        // BIND ELEMENTS
        this.bindElements();
    }


    cacheElements () {
        this.isKnowledgeSearch = this.element.classList.contains('knowledge-search');
        this.articleListing = this.element.querySelector('.c-article-listing');
        this.form = this.element.querySelector('[name=form_search]');
        this.formElements = this.form.elements;
        this.searchInput = this.formElements['form_search_input'];
        this.searchButton = this.formElements['form_search_button'];
        this.formatDropdown = Dropdown.prototype.collection[0].$element;
        this.cityDropdown = Dropdown.prototype.collection[1].$element;
        this.categoryDropdown = Dropdown.prototype.collection[2].$element;
        this.sourceDropdown = Dropdown.prototype.collection[3].$element;
        this.container = this.element.querySelector('.js-search-list-container');
        this.pagination = this.element.querySelector('.js-search-pagination');
        this.paginate = Array.from(this.pagination.querySelectorAll('.js-paginate'));
        this.current = this.pagination.querySelector('.js-current');
        this.total = this.pagination.querySelector('.js-total');

        let type = '';
        if (this.isKnowledgeSearch) {
            type = '/knowledge-library';
        }

        const initPromise = axios.get(`/api/search${type}?page=1`)
            .then(response => {
                return response.data;
            })
            .then(data => {
                maxPage = data.last_page;
                this.total.innerHTML = maxPage;
                this.disablePagination(currPage, maxPage);
            })

    }


    bindElements () {

        this.form.addEventListener('submit', e => {
            e.preventDefault();
            const _val = this.searchInput.value;
            let obj = setParam('text', _val);

            togglePreloader();

            setTimeout(() => { this.search(obj); }, 350);
        });


        this.formatDropdown.on('change', e => {
            const _val = this.formatDropdown.val();
            let obj = setParam('format', _val);

            togglePreloader();

            setTimeout(() => { this.search(obj); }, 350);
        });


        this.cityDropdown.on('change', e => {
            const _val = this.cityDropdown.val();
            let obj = setParam('city', _val);

            togglePreloader();

            setTimeout(() => { this.search(obj); }, 350);
        })


        this.categoryDropdown.on('change', e => {
            const _val = this.categoryDropdown.val();
            let obj = setParam('category', _val);

            togglePreloader();

            setTimeout(() => { this.search(obj); }, 350);
        })


        this.sourceDropdown.on('change', e => {
            const _val= this.sourceDropdown.val();

            let obj = setParam('source', _val);

            togglePreloader();

            setTimeout(() => { this.search(obj); }, 350);
        });


        this.bindPagination();

    }


    search(data, num = false) {
        let arrayValues = Array.from(data.values());
        arrayValues = arrayValues.join(' ').replace(/\s+/g, ' ');

        let type = '';
        if (this.isKnowledgeSearch) {
            type = '/knowledge-library';
        }

        let URL = num ? `/api/search${type}?q=${arrayValues}&page=${num}` : `/api/search${type}?q=${arrayValues}`;

        newPromise = axios.get(URL)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const searchData = data.data;
                let appendMarkUp;

                this.container.innerHTML = '';
                this.articleListing.classList.remove('empty');

                for (let i = 0; i < searchData.length; i++) {
                    appendMarkUp = renderArticleItemTemp(searchData[i], this.isKnowledgeSearch);
                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {
                togglePreloader();

                if (data.next_page_url == null && data.prev_page_url == null) {
                    this.pagination.classList.add('is-hidden');
                } else {
                    this.pagination.classList.remove('is-hidden');
                }

                maxPage = data.last_page;

                this.total.innerHTML = maxPage;

                return data;
            })
            .then(data => {
                this.disableFilterItems(this.formatDropdown, data.formats);
                this.disableFilterItems(this.cityDropdown, data.cities);
                this.disableFilterItems(this.categoryDropdown, data.categories);
                this.disableFilterItems(this.sourceDropdown, data.sources);

                if (data.data.length < 1) {
                    this.container.innerHTML = '';
                    this.articleListing.classList.add('empty');
                    this.container.insertAdjacentHTML('beforeend', noResultsTemp('Your search returned no results.', 'Try a different search term or changing your filters.'));
                }
            })
            .catch(error => {
                console.error(error);
            })
    }


    bindPagination () {
        this.paginate.forEach(item => {
            item.addEventListener('click', e => {
                const paginate = item.getAttribute('data-paginate');

                if (item.getAttribute('disabled')) { return; }

                switch(paginate) {
                    case 'prev':
                        currPage--;
                        break;
                    case 'next':
                        currPage++;
                        break;
                    case 'first':
                        currPage = 1;
                        break;
                    case 'last':
                        currPage = maxPage;
                        break;
                }

                if (currPage <= 1) { currPage = 1; }
                if (currPage > maxPage) { currPage = maxPage; }

                togglePreloader();

                setTimeout(() => {
                    this.search(params, currPage);
                    this.current.innerHTML = currPage;
                    this.disablePagination(currPage, maxPage)
                }, 350);

                return currPage;
            });


        })
    }



    // DISABLE FILTER ITEMS
    disableFilterItems (dropdown, data) {
        const myDropdown = Array.from(dropdown[0].querySelectorAll('option'));

        // remove all disabled attribute
        myDropdown.forEach(item => {
            item.removeAttribute('disabled');
        });


        if (data.length > 0) {
            const filteredArray = filterArray(myDropdown, data);

            filteredArray.forEach(item => {
                if (item.value != dropdown.val() && item.value != '') {
                    item.setAttribute('disabled', '')
                }
            });
        }

        if (Modernizr.touchevents) { return; }

        dropdown.select2('destroy')
            .select2({
                dropdownParent: dropdown.parent()
            });
    }


    disablePagination (curr, max) {
        this.paginate.forEach(item => {
            const paginate = item.getAttribute('data-paginate');
            item.removeAttribute('disabled');
            if (curr == 1) {
                if (paginate == 'first' || paginate == 'prev') { item.setAttribute('disabled', true); }
            } else if (curr == maxPage) {
                if (paginate == 'last' || paginate == 'next') { item.setAttribute('disabled', true); }
            } else {
                item.removeAttribute('disabled');
            }
        })
    }


}
